import { walletTransaction } from "../../helpers/walletTransactionService";

export const state = {
  walletTransactions: [],
  walletTransactionCount: "",
  walletAmount: 0,
  totalCredit: 0,
  totalDebit: 0,
  pagination: {},
  loading: true,
};

export const mutations = {
  getAllWalletTransaction(state, payload) {
    state.walletTransactions = payload.result.data.map((item) => ({
      ...item,
      full_name: item?.users?.full_name,
    }));
    state.loading = false;
    state.pagination = payload.result;
    state.walletTransactionCount = payload.result.total;
    state.walletAmount = payload.result.wallet_balance;
    state.totalCredit = Math.round(payload.result.total_credit);
    state.totalDebit = Math.round(payload.result.total_debit);
  },
  getWalletListRequest(state) {
    state.loading = true;
  },
  getCancelListRequest(state) {
    state.loading = true;
  },
  getWalletTransactionListFailure(state) {
    state.loading = false;
  },
};

export const actions = {
  async getWalletTransaction({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getWalletListRequest");
    await walletTransaction.getWalletTransaction(data).then(
      (response) => {
        commit("getAllWalletTransaction", response.data);
      },
      (error) => {
        commit("getWalletTransactionListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};
export const getters = {
  loading: (state) => state.loading,
  walletTransactionCount: (state) => state.walletTransactionCount,
  walletTransactions: (state) => state.walletTransactions,
  pagination: (state) => state.pagination,
  walletAmount: (state) => state.walletAmount,
  totalCredit: (state) => state.totalCredit,
  totalDebit: (state) => state.totalDebit,
};
